export const REPORTS_DASHBOARD_HEADERS = [
  "Sr No.",
  "Report Name",
  "Date of creation",
  "Generated By",
  "Product",
  "# Batches",
  "# Parameters",
  "Status",
  "Action",
];

export const STEP_SELECT_CHART_TYPE_DEFAULT_CONTROL_CONFIG = {
  movingAverage: false,
  plotAggregation: true,
  ruleset: "nelson",
  selectedRules: ["rule1"],
};

export const STEP_SELECT_CHART_TYPE_DEFAULT_PCCCONFIG = {};

export const STEP_SELECT_CHART_TYPE_DEFAULT_XBAR_CONFIG = {
  selectedBatchId: "",
  ruleset: "nelson",
  selectedRules: ["rule1"],
};

export const STEP_SELECT_CHART_TYPE_DEFAULT_PPCONFIG = {
  selectedCurves: ["norm"],
};
